/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Issue_Same_As_BaseInputs */

const en_reference_issue_same_as_base = /** @type {(inputs: Reference_Issue_Same_As_BaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Must differ from the base colour`)
};

/**
* | output |
* | --- |
* | "Must differ from the base colour" |
*
* @param {Reference_Issue_Same_As_BaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_issue_same_as_base = /** @type {((inputs?: Reference_Issue_Same_As_BaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Issue_Same_As_BaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_issue_same_as_base(inputs)
});